/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from 'vue-property-decorator'
// import {  } from '@/utils/api/customer'
import { menuBtn } from '@/utils/menu_level2_button'
import { setDraftById, getDraftById } from '@/api/draft'
import { getMarketChannelType, getMarketCooperationPrevLevel, getMarketChannelNameByTypeId, getSchoolList, setSchool } from '@/api/common'
import {
    setCustomerBusiness,
    setCustomerBusinessById,
    getCustomerBusinessById,
    duplicateCheckCustomerBusiness,
    getCustomerBusinessFollowListByCustomerBusinessId
} from '@/api/customer'
import { UserModule } from '@/store/modules/user'
import { formatDate } from '@/utils/timeFilter'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import commonData from "@/utils/commonData";

Vue.directive('el-select-loadmore1', { // 指令懒加载
    // bind表示这个自定义指令一绑定到dom上，就开始自动执行
    bind(el: any, binding: any) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        SELECTWRAP_DOM.addEventListener('scroll', function () {
            /**
            * scrollHeight 获取元素内容高度(只读)
            * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
            * clientHeight 读取元素的可见高度(只读)
            * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
            * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
            */
             const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
            if (condition) {
                binding.value();
            }
        });
    },
    // 表示dom插入到页面上的时候自动执行
    // 这些函数都有两个参数，一个是el(使用自定义指令的元素), 一个是binding(记录自定义指令信息的对象)
    inserted(el, binding) {
      el.focus()
    },
    // 表示自定义指令后面的值更新的时候，自动执行
    update() {
        // console.log(this.scrollHeight , this.scrollTop, '11');
    }
  })
@Component({
    components:{
        MoreUsersFilter
    }
})
export default class AddBClassifyCustomer extends Vue {
    loading = false
    addDialog = false  //添加学校
    schoolName = ''
    schoolTypesList = [
        { value: '0', name: '海外大学' },
        { value: '1', name: '国内大学' },
        { value: '2', name: '中学' }
    ]
    schoolType = ''
    repeatName: any =null

    pageType: any = 1
    showInput: any = true
    submitButtonDisabled = false
    cancelTabkBackClueDialog: any = false
    cancelTabkBackRepeatDialog: any = false
    saveType: any = 1
    repeatDialog: any = false
    repeatDetailList: any = []
    repeatStudentName: any = false
    repeatStudentIphone: any = false
    repeatStudentWeixin: any = false
    repeatStudentNameList: any = []
    repeatStudentIphoneList: any = []
    repeatStudentWeixinList: any = []
    customerBusinessDataList: any =[] //相关资料
    formData: any = {
        name: null,
        sourceType: null,
        marketChannelId: null,
        source: null,
        realName: null,
        gender: null,
        phone: null,
        email: null,
        weChat: null,
        attendSchool: null,
        schoolId: null, //学校id
        grade: null,
        specialized: null,
        remark: null,
        parentName: null,
        parentPhone: null,
        parentWeChat: null,
        targetSchool: null,
        achievement: null,
        feedback: null,
        createdAt: new Date(),
        createdUserRealName: null,
        customerBusinessDataList: [],
        directorUserId: null,
        customerBusinessShareUserIdList: [],
        isDraft: '0',
        // ipqSubject: '', // ipq学科方向 // 2023-12-6移除
        courseTypeId: '',// 意向项目类型
        intentionality: '', // 意向程度
        adviser: '', // 送生顾问
        eduTemand: '', // 升学需求
        shareUserIdList:[],
        directorUserRealName:'',
        customerBusinessShareList : [],
    }
    sourceList: any = [
        { name: '合作伙伴', val: '0' },
        { name: '市场渠道', val: '1' },
        { name: '其它', val: '2' },
        // { name: '高校', val: '3' },
        // { name: '分管', val: '4' },
    ]
    schoolArr: any = []
    schoolList: any = []
    sourceChildList: any[] = []
    cooperativePartnerList: { name: string; id: number }[] = [] // 合作伙伴列表
    cascaderProps = {
        value: 'id',
        label: 'name',
        expandTrigger: 'click',
        lazy: true,
        lazyLoad: this.cascaderLazyload
    }
    rules = {
        name: [
            {required: true, message: '请输入客户名称', trigger: 'blur'},
        ],
        sourceType: [
            {required: true, message: '请输入来源', trigger: 'change'}
        ],
        source: [
            {required: true, message: '请选择具体来源名称', trigger: 'change'}
        ],
        courseTypeId: [
            {required: true, message: '请选择意向项目类型', trigger: 'change'},
        ],
        intentionality: [
            {required: true, message: '请选择意向程度', trigger: 'change'},
        ],
        adviser: [
            {required: true, message: '请输入送生顾问', trigger: 'blur'},
        ]
    }
    gradeList = [  // 年级列表
        '美制7年级/英制8年级/初一（普高）',
        '美制8年级/英制9年级/初二（普高）',
        '美制9年级/英制10年级/初三（普高）',
        '美制10年级/英制11年级/高一（普高）',
        '美制11年级/英制12年级/高二（普高）', '美制12年级/英制13年级/高三（普高）',
        '大学一年级',
        '大学二年级',
        '大学三年级',
        '大学四年级',
        '研究生及以上',
        '已毕业'
    ]
    IPQList = [
        '金融/金融工程',
        '经济学',
        '市场营销 （广告学，奢侈品管理）',
        'PPE（政经哲）',
        '酒店管理/旅游管理',
        '管理学',
        '人力资源管理',
        '体育管理',
        '会计学',
        '行为经济学',
        '心理学（教育心理，犯罪心理，体育心理）',
        '教育',
        '法学',
        '传媒（新闻，传播，文化传媒）',
        '历史',
        '国际关系',
        '性别研究',
        '社会学',
        '哲学（伦理学，逻辑学）',
        '公共政策管理',
        ' 语言学',
        '文学',
        '人类学/考古学',
        '建筑/电影/音乐/视觉艺术',
        '计算机（计算机科学，计算机工程）',
        '机械工程（流体力学）',
        '电子工程',
        '物理',
        '天文学',
        '应用数学（数据科学）',
        '数学',
        '生物（药学，医学，营养学，生物化学）',
        '公共卫生（生物统计）',
        '化学',
        '环境工程/环境科学',
        '土木工程',
        '地理/地质'
    ]
    operationShow = true
    draftId: null
    page = null
    scrollHeight: any = null
    scrollTop: any = null
    clientHeight: any =null
    name: any =null
    marketLevelPage = 1
    marketLevelSize = 20
    // marketLevelTotal = 0
    cooperativePartnerName = ''
    marketLevelloading = false
    eduTemandOptions = [ '留学', '高考', '考研', '保研', '考博', '无升学需求' ];
    typeList= commonData.projectTypeArray
    tableData=[] // 跟进记录表
    eduTemand = []

    followTotal = 0
    followLimit = 20
    followPage = 1
    previewVisible = false
    previewPath = ''
    previewName = ''
    informationListImg = []
    oldShareUserIdList=[]
    get pageTitle() {
        let str = '新建B端客户'
        if (!this.showInput) if (this.$route.query.id) str = 'B端客户详情'
        if (this.showInput) if (this.$route.query.id) str = '编辑B端客户'
        return str
    }

    formatDate = formatDate
    menuBtn = menuBtn

    created() {
        this.pageType = Number(this.$route.query.type)
        if (this.pageType === 2) {
            this.showInput = false

        }
        if (this.$route.query.id) {
            this.getTableData()
        }
        this.$nextTick(async () => {
            if (this.pageType === 2 || this.pageType === 3) {
                await this.getDetail(this.pageType)
                await this.sourceChange(1)
            }
        })
        this.getSchoolList()
    }
    get UserName() {
        return UserModule.userName
    }

    get userId() {
        return UserModule.userId
    }

    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }

    // 客户名称失去焦点 ---
    handleBlur() {
        const reg = /^[a-zA-Z\u4E00-\u9fa5\uF900-\uFAFF\u3105-\u312D\u3400-\u4DBF]+(?:\s+[a-zA-Z\u4E00-\u9fa5\uF900-\uFAFF\u3105-\u312D\u3400-\u4DBF]+)*$/
        if (!reg.test(this.formData.name)) {
            this.$message.error('客户名称，只允许字母和汉字，前后不可存在空格')
        }
    }


    // 详情页展示跟进记录
    async getTableData() {
        const data: any = await getCustomerBusinessFollowListByCustomerBusinessId({
            customerBusinessId: Number(this.$route.query.id),
            limit: this.followLimit ,
            page: this.followPage
        })
        this.followTotal = data.allNum
        this.tableData = data.customerBusinessFollowList
        this.tableData = this.tableData.map((item: any) => ({...item, isEdit: false}))
    }

    saveCustomer(type: any) {
        // if (!this.formData.name) { this.$message.error('客户名称不能为空'); return }
        // if (!this.formData.sourceType) { this.$message.error('来源不能为空'); return }
        // if (!this.formData.source) { this.$message.error('具体来源名称不能为空'); return }
        // if (!this.formData.courseTypeId) { this.$message.error('意向项目类型不能为空'); return }
        // if (!this.formData.intentionality) { this.$message.error('意向程度不能为空'); return }
        // if (!this.formData.adviser) { this.$message.error('送生顾问不能为空'); return }
        // if (this.formData.ipqSubject === null) {
        //     this.formData.ipqSubject = ''
        // } // 2023-12-6移除

        const reg = /^[a-zA-Z\u4E00-\u9fa5\uF900-\uFAFF\u3105-\u312D\u3400-\u4DBF]+(?:\s+[a-zA-Z\u4E00-\u9fa5\uF900-\uFAFF\u3105-\u312D\u3400-\u4DBF]+)*$/;
        if (!reg.test(this.formData.name)) {
            this.$message.error('客户名称，只允许字母和汉字，前后不可存在空格')
            return false
        }

        (this.$refs.ruleFormnew as HTMLFormElement).validate((valid: boolean) => {
            if (valid) {

                this.saveType = type
                // if (this.repeatStudentName || this.repeatStudentWeixin || this.repeatStudentIphone) {
                if (this.repeatStudentName) {
                    this.cancelTabkBackClueDialog = true
                    return
                } else {
                    if (this.saveType === 2) {
                        this.cancelTabkBackRepeatDialog = true
                    } else {
                        this.confirmCancelTakeBackClue()
                    }
                }

            }
        })
    }


    handleEduTemand(val) {
        this.formData.eduTemand = val.toString();
    }

    async confirmSchool() {
        await setSchool({name: this.schoolName, types: this.schoolType})
            this.$message.success('新建学校成功')
            this.formData.attendSchool = this.schoolName
            const result: any = await getSchoolList({page: 1,  name: this.schoolName })
            const schoolItem = result.schoolList.filter(item => item.name === this.schoolName)[0]
            this.formData.schoolId = schoolItem.id
            this.schoolList = result.schoolList
            this.schoolName = ''
            this.schoolType = ''
            this.addDialog = false
    }

    async changeStudentName(type: any) {
        const obj: any = {
            id: Number(this.$route.query.id) || null,
            types: type,
            values: null
        }
        if (this.pageType === 3) {
            obj.id = this.draftId
        }
        if (type === 0) {
            obj.values = this.formData.name
        } else if (type === 1) {
            obj.values = this.formData.weChat
        } else if (type === 2) {
            obj.values = this.formData.phone
        }
        if (!obj.values) return
        const data: any = await duplicateCheckCustomerBusiness(obj)
        if (type === 0) {
            if (data.result.length) {
                this.repeatStudentNameList = data.result
                this.repeatStudentName = true
            } else {
                this.repeatStudentName = false
                this.repeatStudentNameList = []
            }
        }
        if (type === 1) {
            if (data.result.length) {
                this.repeatStudentWeixinList = data.result
                this.repeatStudentWeixin = true
            } else {
                this.repeatStudentWeixin = false
                this.repeatStudentWeixinList = []
            }
        }
        if (type === 2) {
            if (data.result.length) {
                this.repeatStudentIphoneList = data.result
                this.repeatStudentIphone = true
            } else {
                this.repeatStudentIphone = false
                this.repeatStudentIphoneList = []
            }
        }
    }
    edit() {
        this.showInput = true
        this.changeStudentName(0)
        this.changeStudentName(1)
        this.changeStudentName(2)
    }

    lookRrepeat(type: any) {
        if (type === 0) {
            this.repeatDetailList = this.repeatStudentNameList
        } if (type === 1) {
            this.repeatDetailList = this.repeatStudentWeixinList
        }
        if (type === 2) {
            this.repeatDetailList = this.repeatStudentIphoneList
        }
        this.repeatDialog = true
    }
    async sourceChange(type: any) {
        if (this.formData.sourceType === '1') {
            const data: any = await getMarketChannelType()
            this.sourceChildList = data.marketChannelTypeList
        }
        if (this.formData.sourceType === '0') {
            this.getMarketCooperationPrevLevel()
        }
        if (type !== 1) {
            this.formData.source = ''
            this.formData.marketChannelId = null
        }
    }
    async getDetail(type: any) {
        let result: any = null
        let data = null
        if (type === 2) {
            result = await getCustomerBusinessById(this.$route.query.id)
            this.formData = result.customerBusiness
            data = result.customerBusiness
            if (result.customerBusiness.eduTemand) {
                this.eduTemand = result.customerBusiness.eduTemand.split(',')
            }
        } else {
            result = await getDraftById(this.$route.query.id)
            this.formData = result.result
            data = result.result
            this.draftId = result.result.id
            if (result.result.eduTemand) {
                this.eduTemand = result.result.eduTemand.split(',')
            }
        }

        const arr = []
        data.customerBusinessShareList.forEach((item: any) => {
            arr.push({
                id: item.userId,
                realName: item.userRealName,
            })
        })
        this.$set(this.formData,'directorUserRealName',data.directorUserRealName)
        this.$set(this.formData,'customerBusinessShareList',arr)

        if (data.customerBusinessShareList) {
            const list = data.customerBusinessShareList.map(item => {
                return item.id
            })
            this.$set(this.formData, 'customerBusinessShareUserIdList', list)
            this.oldShareUserIdList = list
        } else {
            this.formData.customerBusinessShareUserIdList = []
        }
        this.formData.customerBusinessDataList.forEach((item: any,index: any)=>{
            if(this.fileExtension(item.url)=='png'|| this.fileExtension(item.url)=='PNG'|| this.fileExtension(item.url)=='JPG' || this.fileExtension(item.url)=='jpg' || this.fileExtension(item.url)=='jpeg'|| this.fileExtension(item.url)=='JPEG'){
                this.customerBusinessDataList.push(item.url)
            }
        })
        this.$forceUpdate()

    }
    fileExtension(type: any) {
        return type.substring(type.lastIndexOf('.') + 1)
    }
    clearSchool() {
        this.formData.schoolId = null
        this.formData.attendSchool = ''
        this.name = null
        this.page = 1
        this.getSchoolList()
    }

    handleSchoolBlur(e){
        if(!this.formData.schoolId){
            this.name = null
            this.page = null
            this.getSchoolList()
        }
    }

    async confirmCancelTakeBackClue() {
        if (!this.formData.directorUserId) {
            this.formData.directorUserId = this.userId
        }
        if (this.saveType == 2) {
            this.formData.isDraft = '1'
        }
        const newobject = JSON.parse(JSON.stringify(this.formData))
        newobject.shareUserIdList=newobject.customerBusinessShareUserIdList

        if ((this.saveType === 1 && !this.$route.query.id) || this.saveType == 2) { // 保存和存草稿
            this.submitButtonDisabled = true

            for (const key in newobject) {
                if (key === 'eduTemand' && newobject[key] == '') {
                    delete newobject[key]
                }
                if (key === 'marketChannelId' && !newobject[key] ) {
                    delete newobject[key]
                }
            }
            setCustomerBusiness(newobject).then(() => {
                this.$message.success('保存成功')
                setTimeout(() => {
                    window.close()
                }, 1500)

            }).catch(() => {
                this.submitButtonDisabled = false
            })
        } else if (this.saveType === 3) { // 编辑
            this.formData.id = Number(this.$route.query.id)
            delete this.formData.customerBusinessLogList

            newobject.shareUserIdList=newobject.customerBusinessShareUserIdList.filter(c=>this.oldShareUserIdList.indexOf(c)==-1)
            newobject.delShareUserIdList=this.oldShareUserIdList.filter(c=>newobject.customerBusinessShareUserIdList.indexOf(c)==-1)
            this.submitButtonDisabled = true
            await setCustomerBusinessById(newobject).then(()=>{
                this.$message.success('编辑成功')
                setTimeout(() => {
                    window.close()
                }, 1500)
            }).catch(() => {
                this.submitButtonDisabled = false
            })

        } else if (this.saveType === 4) { // 草稿箱保存
            const obj: any = {
                id: Number(this.$route.query.id),
                form: newobject,
                isSubmit: '0'
            }
            this.submitButtonDisabled = true
            await setDraftById(obj).then(() => {
                this.$message.success('保存草稿成功')
                setTimeout(() => {
                    window.close()
                }, 1500)
            }).catch(() => {
                this.submitButtonDisabled = false
            })

        } else if (this.saveType === 5) { // 草稿箱提交
            const obj: any = {
                id: Number(this.$route.query.id),
                form: newobject,
                isSubmit: '1'
            }
            this.submitButtonDisabled = true
            setDraftById(obj).then(() => {
                this.$message.success('提交草稿成功')
                setTimeout(() => {
                    window.close()
                }, 1500)
            }).catch(() => {
                this.submitButtonDisabled = false
            })
        }
    }
    reseat() {
        this.cancelTabkBackClueDialog = false
        this.cancelTabkBackRepeatDialog = false
    }
    async handleUploadSuccess(res, file, fileList) {
        if (res.error.returnCode !== 0) {
            this.$message.error(`上传失败，${res.error.returnMessage}`)
            return
        }
        this.$message.success('上传成功')
        const obj = { name: file.name, url: res.data.ossUrl }
        this.formData.customerBusinessDataList.push(obj)
    }
    async handleUploadError() {
        this.$message.error('上传失败')
    }
    async handleUploadRemove(file, fileList) {
        this.formData.customerBusinessDataList = fileList
    }
    async cascaderLazyload(node: any, reslove: any) {
        if (node.level === 0) { reslove(); return }
        const data: any = await getMarketChannelNameByTypeId(node.value)
        let nodes: any[] = []
        nodes = data.marketChanneNamelList.map((item: any) => ({
            id: item.id,
            name: item.name,
            leaf: node.level >= 1
        }))
        reslove(nodes)
    }

    changeSourceName(val: any) {
        const node = (this.$refs['cascader'] as HTMLFormElement).getCheckedNodes()[0]
        this.formData.marketChannelId = node.value
        this.formData.source = node.label
    }
    async getSchoolList() {
        const data: any = await getSchoolList({page: this.page,  name: this.name})
        this.schoolList = [...this.schoolList, ...data.schoolList]
        const result = []
        const obj = {}
        for(let i =0; i<this.schoolList.length; i++){
            if(!obj[this.schoolList[i].id]){
                result.push(this.schoolList[i]);
                obj[this.schoolList[i].id] = true;
            }
        }
        this.schoolList = result
    }
    loadmore() {
        this.page++
        this.getSchoolList();
    }
    async remoteMethod (query: any) {
        this.name = query
        this.page = 1
        if (query !== '') {
            const result: any = await getSchoolList({page: this.page,  name: query })
            this.schoolList = result.schoolList
        } else {
          this.schoolList = []
            this.getSchoolList();
        }
    }
    async handleSchool(){
        if((this.schoolList.length == 0 || !this.name) && !this.formData.attendSchool){
            this.name = null
            this.page = 1
            const result: any = await getSchoolList({page: this.page,  name: this.name })
            this.schoolList = result.schoolList
        }
        if(this.formData.attendSchool){
            this.schoolList = []
            this.page = 1
            const result: any = await getSchoolList({page: this.page,  name: this.formData.attendSchool })
            this.schoolList = result.schoolList
        }
    }
    changeSchool (val) {
        this.formData.attendSchool = val
        this.formData.schoolId = this.schoolList.find(item=> item.name === val).id
    }
    @Watch('UserName', { deep: true })
    changepageType(val: any) {
        if (val && !this.$route.query.id) {
            this.formData.createdUserRealName = this.UserName
        }
    }

    async getMarketCooperationPrevLevel() {
        const data: any = await getMarketCooperationPrevLevel(
            {
                page: this.marketLevelPage,
                limit: this.marketLevelSize,
                name: this.cooperativePartnerName
            }
        )
        this.cooperativePartnerList = [...this.cooperativePartnerList, ...data.marketCooperationList]
        const result = []
        const obj = {}
        for (let i = 0; i < this.cooperativePartnerList.length; i++) {
            if (!obj[this.cooperativePartnerList[i].id]) {
                result.push(this.cooperativePartnerList[i]);
                obj[this.cooperativePartnerList[i].id] = true;
            }
        }
        this.cooperativePartnerList = result
    }



    async remoteCooperativePartnerMethod(query: any) {
        this.cooperativePartnerName = query
        this.marketLevelPage = 1
        this.marketLevelSize = 20
        if (query !== '') {
            const result: any = await getMarketCooperationPrevLevel({
                page: this.marketLevelPage,
                limit: this.marketLevelSize,
                name: query
            })
            this.cooperativePartnerList = result.marketCooperationList
        }else{
            this.cooperativePartnerList = []
            this.getMarketCooperationPrevLevel()
        }
    }

    changeCooperativePartner(val) {
        this.formData.source = val
        this.formData.sourceId = this.cooperativePartnerList.find(item => item.name === val).id
    }

    clearCooperativePartner() {
        this.cooperativePartnerList = []
        this.formData.sourceId = null
        this.formData.source = ''
        this.cooperativePartnerName = null
        this.marketLevelPage = 1
        this.marketLevelSize = 20
        this.getMarketCooperationPrevLevel()
    }

    cooperativePartnerLoadmore() {
        this.marketLevelPage = 1
        this.marketLevelSize += 20
        this.getMarketCooperationPrevLevel();
    }

    handlePreview(file) {
        this.previewPath = file.url
        this.previewName = file.name
        this.previewVisible = true
    }

    changedirectorUserId(e){
        this.formData.directorUserId = e.id
    }

    changecustomerBusinessShareUserIdList(e) {
        if (e.id.length > 0) {
            this.formData.customerBusinessShareUserIdList = e.id
        } else {
            this.formData.customerBusinessShareList = []
        }
        this.$forceUpdate()
    }

    @Watch('userId', { deep: true })
    changeyUserId(val: any) {
        if (!this.formData.directorUserId) {
            this.formData.directorUserId = val
        }
    }

    @Watch('UserName', { deep: true })
    handle(val: any) {
        if (!this.formData.directorUserRealName) {
            this.formData.directorUserRealName = val
        }
    }
}
